import { HsMatrix4 } from '../../math-new/objects/matrix4.class';
import { HsQuaternion } from '../../math-new/objects/quaternion.class';
import { hsMergeGeometries } from '../geometry-utils/merge-geometries.function';
import type { HsRegularGeometryData } from '../geometry-utils/regular-geometry-data.class';
import { hsGenerateConeGeometryData } from './generate-cone-geometry-data.function';
import { hsGenerateCylinderGeometryData } from './generate-cylinder-geometry-data.function';

export function hsGenerateArrowGeometryData(
  quality: number = 12,
  handWidth: number = 0.5,
  pointerWidth: number = 1
): HsRegularGeometryData {
  const cylinderData: HsRegularGeometryData = hsGenerateCylinderGeometryData(quality, false, true);
  const coneData: HsRegularGeometryData = hsGenerateConeGeometryData(quality, true);
  const cylinderMatrix: HsMatrix4 = HsMatrix4.compose([0, 0, 0], [0, 0, 0, 1], [handWidth, 1, handWidth]);
  const cylinderDataWithMatrix: [HsRegularGeometryData, HsMatrix4] = [cylinderData, cylinderMatrix];
  const direction: HsQuaternion = HsQuaternion.makeFromAxisAndAngle([1, 0, 0], 0);
  const rotation: HsMatrix4 = HsMatrix4.compose([0, 1, 0], direction.values, [pointerWidth, 1, pointerWidth]);
  const coneDataWithMatrix: [HsRegularGeometryData, HsMatrix4] = [coneData, rotation];
  cylinderDataWithMatrix;
  const data: HsRegularGeometryData = hsMergeGeometries([cylinderDataWithMatrix, coneDataWithMatrix]);
  return data;
}
